// Simple dependency-free SVG line chart for simulation scores over time.
export function ScoreChart({ points }) {
  // points: [{label, value 0-100}]
  const W = 320, H = 120, pad = 24;
  if (!points || points.length === 0) return null;
  const n = points.length;
  const maxV = 100;
  const x = (i) => n === 1 ? W / 2 : pad + (i * (W - pad * 2)) / (n - 1);
  const y = (v) => H - pad - (v / maxV) * (H - pad * 2);
  const path = points.map((p, i) => `${i === 0 ? "M" : "L"} ${x(i).toFixed(1)} ${y(p.value).toFixed(1)}`).join(" ");
  return (
    <svg viewBox={`0 0 ${W} ${H}`} className="w-full" data-testid="score-chart">
      {[0, 50, 100].map((g) => (
        <g key={g}>
          <line x1={pad} x2={W - pad} y1={y(g)} y2={y(g)} stroke="rgba(255,255,255,0.1)" strokeWidth="1" />
          <text x={2} y={y(g) + 3} fill="rgba(255,255,255,0.35)" fontSize="9">{g}</text>
        </g>
      ))}
      {n > 1 && <path d={path} fill="none" stroke="#00E5FF" strokeWidth="2.5" style={{ filter: "drop-shadow(0 0 4px #00E5FF)" }} />}
      {points.map((p, i) => (
        <g key={i}>
          <circle cx={x(i)} cy={y(p.value)} r="4" fill={p.value >= 70 ? "#00FF7F" : p.value >= 50 ? "#FFD700" : "#FF3366"} />
          <text x={x(i)} y={H - 6} fill="rgba(255,255,255,0.4)" fontSize="8" textAnchor="middle">{p.label}</text>
        </g>
      ))}
    </svg>
  );
}
